import type { Theme } from '@emotion/react';
import type { ButtonColor, ButtonSize } from './types';

export const BUTTON_HEIGHT: Record<ButtonSize, string> = {
  small: '32px',
  medium: '40px',
  large: '52px',
  xl: '60px',
};

export const BUTTON_FONT_SIZE: Record<ButtonSize, number> = {
  small: 14,
  medium: 14,
  large: 16,
  xl: 16,
};

export const BUTTON_COLOR = (
  theme: Theme,
): Record<
  ButtonColor,
  {
    default: { text?: string; background?: string; border?: string };
    outlined: { text?: string; background?: string; border?: string };
  }
> => {
  return {
    transparent: {
      default: { text: theme.color.medium.default, background: theme.color.tranparent },
      outlined: { text: theme.color.medium.default, background: theme.color.tranparent },
    },
    light: {
      default: { text: theme.color.blue.default, background: theme.color.light.default },
      outlined: { text: theme.color.light.default, background: theme.color.tranparent },
    },
    purple: {
      default: { text: theme.color.light.default, background: theme.color.purple.default },
      outlined: { text: theme.color.purple.default, background: theme.color.light.default },
    },
    blue: {
      default: { text: theme.color.light.default, background: theme.color.blue.default },
      outlined: { text: theme.color.blue.default, border: theme.color.blue.default },
    },
    lightBlue: {
      default: { text: theme.color.blue.default, background: theme.color.blue.lightBlue },
      outlined: { text: theme.color.blue.default, border: theme.color.blue.lightBlue },
    },
    yellow: {
      default: { text: theme.color.light.default, background: theme.color.yellow.default },
      outlined: { border: theme.color.yellow.default },
    },
    red: {
      default: { text: theme.color.light.default, background: theme.color.red.default },
      outlined: { border: theme.color.red.default },
    },

    medium: {
      default: { text: theme.color.medium.default, background: theme.color.light.default },
      outlined: { text: theme.color.medium.default, background: theme.color.light.default },
    },

    dark: {
      default: { text: theme.color.dark.default, background: theme.color.light.default },
      outlined: { text: theme.color.dark.default, background: theme.color.light.default },
    },

    green: {
      default: { text: theme.color.light.default, background: theme.color.green.default },
      outlined: { text: theme.color.light.default, background: theme.color.green.default },
    },
    white: {
      default: { text: theme.color.black.whatsapp, background: theme.color.light.whatsapp },
      outlined: { text: theme.color.black.whatsapp, background: theme.color.light.whatsapp },
    },
    whatsappGreen: {
      default: { text: theme.color.light.whatsapp, background: theme.color.green.whatsapp },
      outlined: { text: theme.color.light.whatsapp, background: theme.color.green.whatsapp },
    },
  };
};
